


// Generated from io.spcfy.api.orders.filter.SearchFilter$FilterType

export type FilterTypeKey =
  "SUBSTR" |
  "NOT_NULL" |
  "IS_NULL" |
  "LESS_THAN" |
  "GREATER_THAN" |
  "LESS_THAN_OR_EQUAL" |
  "GREATER_THAN_OR_EQUAL" |
  "EQUAL" |
  "LIKE" |
  "AND" |
  "OR";


export interface FilterTypeDTO {
  key: FilterTypeKey;    
}


export const FilterTypes: Record<FilterTypeKey, FilterTypeDTO> = {
  SUBSTR: { key: "SUBSTR",  },
  NOT_NULL: { key: "NOT_NULL",  },
  IS_NULL: { key: "IS_NULL",  },
  LESS_THAN: { key: "LESS_THAN",  },
  GREATER_THAN: { key: "GREATER_THAN",  },
  LESS_THAN_OR_EQUAL: { key: "LESS_THAN_OR_EQUAL",  },
  GREATER_THAN_OR_EQUAL: { key: "GREATER_THAN_OR_EQUAL",  },
  EQUAL: { key: "EQUAL",  },
  LIKE: { key: "LIKE",  },
  AND: { key: "AND",  },
  OR: { key: "OR",  }
};
